module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_saved-f62b830b3f5cf1a5c2aae0575c129be4.svg";